// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__17l7N","detailsBorder":"styles_detailsBorder__1WA8D"};